import { Coordinate } from 'types/map';
import { Report, ReportDB } from 'types/reports';

function toLatLng(path): Coordinate {
  return [path.lat, path.lng];
}

export async function getReports(): Promise<Report[]> {
  return fetch(`${process.env.SERVER_URL}/report`, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  })
    .then((res) => res.json())
    .then((res: ReportDB[]) => {
      const data = [];
      res.forEach((report, index) => {
        if (report.latlng) {
          data[index] = {
            ...report,
            latlng: [report.latlng.x, report.latlng.y],
          };
        }
      });

      return data;
    })
    .catch((err) => {
      console.log('Fetch report error', err);
      throw err;
    });
}

export async function sendReport(data: Report) {
  const body = { ...data, latlng: toLatLng(data.latlng) };
  return fetch(`${process.env.SERVER_URL}/report`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  }).catch((err) => {
    console.log('Send report error', err);
    throw err;
  });
}

export async function deleteReport(id: string) {
  return fetch(`${process.env.SERVER_URL}/report/${id}`, {
    method: 'DELETE',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ id }),
  })
    .then((res) => res.json())
    .then((res) => {
      if (res.status && res.status !== 200) {
        throw 'Delete report failed';
      }
    })
    .catch((err) => {
      console.log('Delete report error', err);
      throw err;
    });
}
